import _defineProperty from "@babel/runtime/helpers/defineProperty";
/** @jsx jsx */
/* eslint-disable @repo/internal/react/no-clone-element */
import { cloneElement, Component } from 'react';
import { jsx } from '@emotion/react';
import toItemId from '../../utils/to-item-id';
import Items from './items';
export default class Item extends Component {
  render() {
    // eslint-disable-next-line react/prop-types
    const {
      depth,
      data,
      render,
      loadingLabel
    } = this.props;
    const renderedRow = render(data);
    if (!renderedRow) {
      return null;
    }
    const {
      itemId,
      items
    } = renderedRow.props;
    return /*#__PURE__*/cloneElement(renderedRow, {
      depth,
      data,
      loadingLabel,
      renderChildren: () => jsx("div", {
        id: toItemId(itemId)
      }, jsx(Items, {
        parentData: data,
        depth: depth,
        items: items,
        render: render,
        loadingLabel: loadingLabel
      }))
    });
  }
}
_defineProperty(Item, "defaultProps", {
  depth: 0
});